<template>
  <button
    class="order__button"
    :aria-label="computedAriaLabel"
    :aria-disabled="hasDetails"
    data-testid="order-row"
    @click="handleOnClick"
  >
    <Row
      :class="computedRowClass"
      :chevron="hasDetails"
      :has-interaction="hasDetails"
      class="order__row"
    >
      <p
        slot="top-left"
        class="order__row__description"
        :title="order.description"
      >
        {{ order.description }}
      </p>
      <p
        slot="bottom-left"
        class="order__row__date"
        :title="order.executedAt.long"
      >
        {{ order.executedAt.long }}
      </p>
      <p slot="top-right" class="order__row__price">
        <Money width="100%">
          {{ order.movementTotalPrice.formatted }}
        </Money>
      </p>
      <template #bottom-right>
        <ChipStatus
          :status="order.status.value"
          :label="order.status.formatted"
        />
      </template>
    </Row>
  </button>
</template>

<script lang="ts">
import { Component, Vue, Prop, Emit } from 'vue-property-decorator';

import { ChipStatus, Row } from '@warrenbrasil/nebraska-web';
import { Money } from '@/modules/common/components/MoneyV2';

import { OrderSummary } from '@/modules/trade/services/orders';

@Component({
  components: {
    ChipStatus,
    Row,
    Money
  }
})
export default class OrderRow extends Vue {
  @Prop({ type: Object, required: true })
  readonly order!: OrderSummary;

  @Emit('on-row-click')
  emitOnRowClick() {
    return this.order;
  }

  handleOnClick() {
    if (this.hasDetails) this.emitOnRowClick();
  }

  get computedAriaLabel() {
    return `Ver detalhes da ordem de ${this.order.description}`;
  }

  get hasDetails() {
    return this.order.clickable;
  }

  get computedRowClass() {
    return this.hasDetails ? '' : 'order__row--spacing';
  }
}
</script>

<style lang="less" scoped>
.order {
  &__button {
    cursor: auto;
    width: 100%;
    padding: 0;
  }

  &__row {
    &__price {
      white-space: nowrap;
    }

    &__date {
      display: -webkit-box;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
      overflow: hidden;
      word-break: break-all;
      white-space: normal;
      margin-right: @size-spacing-x150;
    }

    &__description {
      display: -webkit-box;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
      overflow: hidden;
      word-break: break-all;
      white-space: normal;
    }

    /deep/ .container-left {
      flex: auto;
    }

    &--spacing {
      /deep/ .container-right {
        margin-right: @size-spacing-x450;
      }
    }
  }
}
</style>
